import { RouteConfig } from "vue-router";

export const REmployeeProfileEmployment: RouteConfig = {
  path: "employment",
  name: "EmployeeProfileEmployment",
  component: () =>
    import(
      /* webpackChunkName: "employee-profile-employment" */
      "./VEmployeeProfileEmployment.vue"
    ),
  meta: {
    title: "My Profile",
    label: "employment",
    tabName: "employee_employment",
    alias: "employment",
  },
};
